import { branding } from '@/branding/config';

export function applyBranding(): void {
    document.title = branding.meta.title;

    const descriptionElement = document.querySelector<HTMLMetaElement>("meta[name='description']");

    if (descriptionElement) {
        descriptionElement.content = branding.meta.description;
    }

    const faviconElement = document.querySelector<HTMLLinkElement>("link[rel='icon']");

    if (faviconElement) {
        faviconElement.href = branding.favicon;
    }

    const rootStyle = document.documentElement.style;
    rootStyle.setProperty('--primary', branding.colors.primary);
    rootStyle.setProperty('--primary-foreground', branding.colors.primaryForeground);
    rootStyle.setProperty('--sidebar-primary', branding.colors.sidebarPrimary);
    rootStyle.setProperty('--sidebar-primary-foreground', branding.colors.sidebarPrimaryForeground);
}
